/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Day_Done_RunningInputs */

const en_us2_today_day_done_running = /** @type {(inputs: Today_Day_Done_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

const pt_br2_today_day_done_running = /** @type {(inputs: Today_Day_Done_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em andamento`)
};

const es_419_today_day_done_running = /** @type {(inputs: Today_Day_Done_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En curso`)
};

const pt_pt2_today_day_done_running = /** @type {(inputs: Today_Day_Done_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A decorrer`)
};

const fr_fr2_today_day_done_running = /** @type {(inputs: Today_Day_Done_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const de_de2_today_day_done_running = /** @type {(inputs: Today_Day_Done_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft`)
};

const it_it2_today_day_done_running = /** @type {(inputs: Today_Day_Done_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In corso`)
};

/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Today_Day_Done_RunningInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_done_running = /** @type {((inputs?: Today_Day_Done_RunningInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_Done_RunningInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_done_running(inputs)
	if (locale === "es-419") return es_419_today_day_done_running(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_done_running(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_done_running(inputs)
	if (locale === "de-DE") return de_de2_today_day_done_running(inputs)
	if (locale === "it-IT") return it_it2_today_day_done_running(inputs)
	return en_us2_today_day_done_running(inputs)
});
export { today_day_done_running as "today.day_done_running" }